"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "DownloadExcel___StyledSvg",
  componentId: "sc-89x2q5-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function DownloadExcel(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5l-3-3H6a1 1 0 00-1 1v14a1 1 0 001 1h11a1 1 0 001-1V5zm-4-2v3h3v11H6V3h8z",
    fill: "#707070"
  }), _react["default"].createElement("rect", {
    x: 2,
    y: 6,
    width: 11,
    height: 10,
    rx: 1,
    fill: "#177143"
  }), _react["default"].createElement("path", {
    d: "M10.215 9l-1.65 2.422L10.204 14H8.428l-.723-1.348a5.044 5.044 0 01-.21-.454h-.02a3.17 3.17 0 01-.2.44L6.548 14H4.775l1.69-2.49L4.878 9h1.787l.713 1.401c.094.186.161.342.2.47h.02c.052-.154.122-.313.21-.48L8.535 9h1.68z",
    fill: "#fff"
  }));
}

var _default = DownloadExcel;
exports["default"] = _default;